import React from 'react';
import api from './../../../services/api';
import { user_token } from '../../../services/Auth';
import SwitchButton from './SwitchButton';
//import { NavLink } from 'react-router-dom';
import GetAge from './GetAge';
import { NavLink} from 'react-router-dom';

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);
export default class GetExam extends React.Component {
  state = {
    user: []
  }

  alertaButton() {
    alert("Funcionalidade ainda não disponível, entre em contato com Organizador!");
  }

  componentDidMount() {
    //api.get(`/user/${this.props.user_id}`, {headers: {'x-access-token': token}})
    apiProfessional.getUser(this.props.user_id)
      .then(res => {
        const user = res.data;
        this.setState({ user });
      })
  }

  render() {
    return (
      <ul>
        {this.state.user.map(details =>
          <>
            <p id="RI-Title-Cadastro-Paciente" >ID do(a) Paciente: </p><p>{details.numericID}</p>
            <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Paciente: </p><p>{details.name}</p>
            {details.user_type === "Paciente" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Paciente da instituição</p></> :
              details.user_type === "Funcionario" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Funcionário da instituição</p></> :
                null}
            <p id="RI-Title-Cadastro-Paciente" >Data de Nascimento do(a) Paciente: </p><p>{details.birth}</p>
            <p id="RI-Title-Cadastro-Paciente" >CPF do(a) Paciente: </p><p>{details.cpf}</p>
            <p id="RI-Title-Cadastro-Paciente" >Idade do(a) Paciente: </p><p><GetAge birth={details.birth} /> anos</p>
            <p id="RI-Title-Cadastro-Paciente" >Genêro do(a) Paciente: </p><p>{details.gender}</p>
            <p id="RI-Title-Cadastro-Paciente" >Endereço do(a) Paciente: </p><p>{details.adress}</p>
            <hr id="coloring_line" />

          <div id="collapsed-PS_Painel">
            <a href={this.props.meeting_link} target="_blank">
              <button id="option-PS-Painel">Iniciar chamada por vídeo</button>
            </a>
            <SwitchButton _id={details.first} exam_id={this.props.exam_id}/>
          </div>
          <div>
            <br/>
            <hr id="coloring_line"/>
            <p id="RI-Title-Cadastro-Paciente" >Caso o botão iniciar video chamada não funcione copie e cole esse link no navegador: <a href = {this.props.meeting_link} target='_blank' >{this.props.meeting_link}</a></p>
            <br/>
            <p id="RI-Title-Cadastro-Paciente" >Caso tenha alguma dúvida acesse o manual do Profissional da Saúde<a href = 'https://drive.google.com/file/d/1TzorBWVKbljmqvBmIznsGpP7ajZbdk0a/view' target='_blank'> clicando aqui </a></p>
          </div>
        </>)}

      </ul>
    )
  }
}